export default __webpack_public_path__ + "static/media/May2010.3521d1e1.png";